module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading.initial) ? _c('div', [_vm._v("Loading...")]) : _vm._e(), _vm._v(" "), (!_vm.loading.initial) ? _c('div', {
    directives: [{
      name: "masonry",
      rawName: "v-masonry"
    }],
    staticClass: "row row--sml flex-wrap text-sm"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      directives: [{
        name: "masonry-tile",
        rawName: "v-masonry-tile"
      }],
      staticClass: "col col--sml w-full sm:w-full md:w-1/2 lg:w-1/4 xl:w-1/4"
    }, [_c('div', {
      staticClass: "box box--p-0 box--overflow relative mb-6 shadow"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "pr-8 pl-6 pt-12 pb-4"
    }, [_c('p', [_c('a', {
      staticClass: "text-social no-underline font-bold",
      attrs: {
        "href": item.permalink_url,
        "target": "_blank"
      }
    }, [_vm._v("@BananaMoon")]), _vm._v("\n                        " + _vm._s(item.message) + "\n                    ")]), _vm._v(" "), _c('p', {
      staticClass: "mb-0 text-grey-dark"
    }, [_c('small', [_vm._v("\n                            @BananaMoon - "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.moment(item.created_time).fromNow())
      }
    })])])]), _vm._v(" "), (typeof item.full_picture != 'undefined') ? _c('div', {
      staticClass: "social-image"
    }, [_c('img', {
      attrs: {
        "src": item.full_picture
      }
    })]) : _vm._e()])])
  })) : _vm._e(), _vm._v(" "), (_vm.more) ? _c('div', {
    staticClass: "row mt-4 md:mt-12"
  }, [_c('div', {
    staticClass: "col w-full text-center"
  }, [_c('a', {
    staticClass: "btn btn--lg btn--pill btn--bordered btn--bordered--grey-darker btn--transparent btn--text--grey-darker btn--hover--grey-darker btn--hover--text--white",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.next
    }
  }, [(!_vm.loading.state) ? _c('span', [_vm._v("Load more")]) : _c('span', [_vm._v("Loading...")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "badge badge--right badge--pill badge--facebook"
  }, [_c('i', {
    staticClass: "fab fa-facebook-f"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69f381b2","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/SocialFeed.vue
// module id = YUil
// module chunks = 1